/**
 * Determine access to Admin Resources from authClient permissions
 *
 * @param permissions
 * @param any
 * @param only
 * @return {boolean}
 */
export const resolveAccess = (permissions, any = [], only = []) => {
    if (permissions) {
        // Note lists of optional (any) or specific (only) against permissions
        const anyLength = any.length;
        const onlyLength = only.length;

        // Permissions might be an array or a string
        const permissionsIsArray = (typeof permissions !== 'string');

        // Check specific permissions (used for displaying limited content to users with less access):
        if (onlyLength) {
            for (let o = 0; o < onlyLength; o++) {
                if (permissionsIsArray) {
                    if (permissions.findIndex(p => p === only[o]) !== -1) {
                        return true;
                    }
                } else {
                    if (permissions === only[o]) {
                        return true;
                    }
                }
            }
            // Do not display for any user except for specified permission
            return false;
        }

        // If permissions equals a string:
        // (Sysops, Sysadmins, Users with sections_all, Users with section: admin may always access)
        if (
            permissions === 'sys_op' || permissions === 'sys_admin' ||
            permissions === 'sections_all' || permissions === 'admin'
        ) {
            return true;
        }

        if (!anyLength && !onlyLength) {
            // If only permissions is provided, Users with section: admin may access
            if (permissionsIsArray) {
                if (permissions.findIndex(p => p === 'admin') !== -1) {
                    return true;
                }
            } else {
                if (permissions.indexOf('admin') !== -1) {
                    return true;
                }
            }
        }

        // If any permission matches requested access:
        if (anyLength) {
            for (let j = 0; j < anyLength; j++) {
                if (permissionsIsArray) {
                    if (permissions.findIndex(p => p === any[j]) !== -1) {
                        return true;
                    }
                } else {
                    if (permissions === any[j]) {
                        return true;
                    }
                }
            }
        }
    }
    return false;
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/authFunctions.js